import { map } from "rxjs/operators";
import { CrudAbstractModel } from "./crud-abstract.model";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { PaginationList } from "../shared/grid/pagination-list.model";
import { HttpParams } from "@angular/common/http";
import { PaginatedResponse } from "../shared/http/paginated-response.model";

@Injectable()
export abstract class CrudAbstractRepository {
  protected http: HttpClient = inject(HttpClient);

  abstract getMapper(): any;

  abstract getEndpoint(): string;

  public list(params: HttpParams = new HttpParams()): Observable<any[]> {
    return this.http
      .get<object[]>(`${environment.apiUrl}/${this.getEndpoint()}/list`, {
        params: params,
      })
      .pipe(map((response) => response.map(this.getMapper())));
  }

  public get(id: number): Observable<any> {
    return this.http
      .get(`${environment.apiUrl}/${this.getEndpoint()}/${id}`)
      .pipe(map((response) => this.getMapper()(response)));
  }

  public paginatedList(
    params: HttpParams = new HttpParams(),
  ): Observable<PaginationList<any>> {
    return this.http
      .get<PaginatedResponse>(`${environment.apiUrl}/${this.getEndpoint()}`, {
        params: params,
      })
      .pipe(
        map(
          (list) =>
            new PaginationList<any>(
              list.items.map(this.getMapper()),
              list.total,
            ),
        ),
      );
  }

  public autocomplete(
    params: HttpParams = new HttpParams(),
  ): Observable<PaginationList<any>> {
    return this.http
      .get<PaginatedResponse>(
        `${environment.apiUrl}/${this.getEndpoint()}/autocomplete`,
        {
          params: params,
        },
      )
      .pipe(
        map(
          (list) =>
            new PaginationList<any>(
              list.items.map(this.getMapper()),
              list.total,
            ),
        ),
      );
  }

  public add(model: CrudAbstractModel): Observable<object> {
    return this.http
      .post(
        `${environment.apiUrl}/${this.getEndpoint()}`,
        model.getRequestParams(),
      )
      .pipe(map((response) => this.getMapper()(response)));
  }

  public save(model: CrudAbstractModel): Observable<object> {
    return this.http.patch(
      `${environment.apiUrl}/${this.getEndpoint()}/${model.getId()}`,
      model.getRequestParams(),
    );
  }

  public delete(model: CrudAbstractModel): Observable<object> {
    return this.http.delete(
      `${environment.apiUrl}/${this.getEndpoint()}/${model.getId()}`,
    );
  }
}
